















































import { Component, Vue } from "vue-property-decorator";
import { SelectorMap } from "@/utility/TemplateOptions";
import NotesPage from "./NotesPage.vue";
import Timer from '@/components/Timer.vue';
import TimedCount from '@/components/TimedCount.vue';
import NineWords from '@/components/NineWords.vue';
import RandomNumbers from '@/components/RandomNumbers.vue';
import Selector from "@/utility/Selector";
import NestedOption from "./NestedOption.vue";

@Component({
  components: {
    NotesPage,
    Timer,
    TimedCount,
    NineWords,
    RandomNumbers,
    NestedOption,
  },
})
export default class ConcussionExam extends Vue {
  private selectors: SelectorMap = {};
  private selectorsLoaded = false;
}

